// import * as VueGoogleMaps from 'vue2-google-maps';

import _ from 'lodash';
import M from 'moment';
import Vue from 'vue';

// var lodash = require('lodash');
// var Vue = require('vue');
// import jQuery from 'jquery';


// var bootstrapdatetimepicker = require('bootstrap-datetimepicker-npm');

import { BootstrapVue } from 'bootstrap-vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Notifications from 'vue-notification';
import VueConfirmDialog from 'vue-confirm-dialog';
import Vuelidate from 'vuelidate'

import getHelpers from './helpers';
import main from './store/main';

const libs = {};
window.exportLib = (key, value) => {
    libs[key] = value;
}

window.importLib = (key) => {
    return libs[key];
}

// var _ = lodash;
window._ = _;
window.lodash = _;
var env = window.env;

Vue.use(Vuex);
Vue.use(VueConfirmDialog);
Vue.use(BootstrapVue);
Vue.use(Loading);
Vue.use(Notifications);
Vue.set(Vue.prototype, 'helpers', getHelpers(env));
Vue.set(Vue.prototype, '_', _);
Vue.use(Vuelidate);
Vue.component('vue-confirm-dialog', VueConfirmDialog.default);
Vue.component('loading', Loading);

Vue.directive('uppercase', {
	update (el) {
		el.value = el.value.toUpperCase()
	},
});

Vue.directive('startcase', {
    bind(el) {
        el.addEventListener('keypress', (e) => {
            let str = e.target.value + 'Z';
            e.target.value = _.startCase(str).slice(0, str.length-1);
        })
    }
});

var store = new Vuex.Store(main);
window.store = store;
window.reloadData = false;
window.mountVueComponent = (id, component) => {
    var root = document.getElementById(id);
    if (root) {
        var data = null;
        var config = null;

        try {
            var content = root.textContent;
            content = JSON.parse(content);
            data = content.data || null;
            config = content.config || null;

        } catch (e) {
            console.info(`Problem parsing data and config for component ${id}`);
        }

        // Vue.use(VueGoogleMaps, {
        //     load: {
        //         key: window.env.GOOGLE_MAP_KEY,
        //         libraries: "places" // necessary for places input
        //     }
        // });

        new Vue({
            el: root,
            store,
            render: h => h(component, {
                props: { initialData: data, config }
            }),
        })
    }
}

window.exportLib('lodash', _);
window.exportLib('moment', M);
// window.exportLib('Vuex', Vuex);
window.exportLib('getHelpers', getHelpers);
// window.exportLib('api', initRest({ ...env }));

window.dispatchEvent(new Event('vue-init'));

_.chain(document.querySelectorAll('script[data-src]'))
    .map((el) => {
        el.src = el.dataset.src;
    })
    .value();